import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 gap-4 px-4" }
const _hoisted_2 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_3 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_4 = { class: "col-span-2" }
const _hoisted_5 = { class: "col-span-2" }
const _hoisted_6 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_7 = { class: "col-span-2 lg:col-span-1" }
const _hoisted_8 = { class: "col-span-2" }
const _hoisted_9 = {
  key: 0,
  class: "col-span-2"
}
const _hoisted_10 = {
  key: 1,
  class: "col-span-2 lg:col-span-1"
}
const _hoisted_11 = {
  key: 2,
  class: "col-span-2 lg:col-span-1"
}

import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	
	const __default__ = { name: 'JobDetailsLocation' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()
	const userStore = _userStore()
	const {t} = useI18n()

return (_ctx: any,_cache: any) => {
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('1'),
        value: __props.job?.fieldData?.type_display || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('11'),
        value: __props.job?.fieldData?.category_display || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('173'),
        value: __props.job?.fieldData?.['job__CONTACTS_SERVICES__contactServicesID::name_display'] || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('217'),
        value: __props.job?.fieldData?.['job__CONTACTS__locationID::company_display'] || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('129'),
        value: __props.job?.fieldData?.['jobs__contacts_services__services__STYLES__stylesID::name_display'] || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('130'),
        value: __props.job?.fieldData?.['jobs__contacts_services__services__THEMES__themesID::name_display'] || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_data_display, {
        loading: __props.loading,
        label: _unref(store).getLabel('146'),
        value: __props.job?.fieldData?.['job__ROOMS__roomID::name_full_display'] || '—'
      }, null, 8, ["loading", "label", "value"])
    ]),
    (_unref(userStore).getContactType == 'Staff')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('17'),
            value: __props.job?.fieldData?.['job__contacts__AREAS_COUNTRIES__locationID::area_display'] || '—'
          }, null, 8, ["loading", "label", "value"])
        ]))
      : _createCommentVNode("", true),
    (_unref(userStore).getContactType == 'Staff')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('23'),
            value: __props.job?.fieldData?.['jobs__PLACES__placeID::name_display'] || '—'
          }, null, 8, ["loading", "label", "value"])
        ]))
      : _createCommentVNode("", true),
    (_unref(userStore).getContactType == 'Staff')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_data_display, {
            loading: __props.loading,
            label: _unref(store).getLabel('913'),
            value: __props.job?.fieldData?.['jobs__LOCATIONS__transportationLocationID::name_display'] || '—'
          }, null, 8, ["loading", "label", "value"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})